import CompanyAccountsTab from 'src/components/pages/Company/CompanyPage/CompanyAccountsTab/CompanyAccountsTab';

export default CompanyAccountsTab;
